<template>
  <div
    class="
      relative
      flex
      items-top
      justify-center
      min-h-screen
      bg-gray-100
    "
  >
    <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
      <div class="flex justify-center pt-8 sm:justify-start">
        <img
          src="/img/RA-logo-02.png"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <img
          src="/img/logo-thnic.svg"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <div class="ml-5">
          <div
            class="text-sm sm:text-2xl text-blue-900"
          >
            Workshop สร้าง Sale Page เปิดร้านออนไลน์ ด้วยเว็บไซต์หน้าเดียว ฉบับจับมือทำ
          </div>
          <div class="text-sm sm:text-sm mt-1 ">
            จัดโดย Robinhood Academy ร่วมกับ มูลนิธิศูนย์สารสนเทศเครือข่ายไทย
          </div>
        </div>
      </div>

      <div class="bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="bg-blue-900 px-6 py-8">
          <div class="text-white text-center text-xl font-semibold">
            ขณะนี้โครงการของเราได้หมดระยะเวลาการสมัครแล้ว ทางเราขอขอบพระคุณในความสนใจในโครงการ
          </div>
          <div class="mt-4 flex justify-center h-10 text-white">โปรดติดตามโครงการดีๆจาก Robinhood Academy และ มูลนิธิศูนย์สารสนเทศเครือข่ายไทย ที่จะเกิดขึ้นอีกในอนาคตนะครับ</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {},
  computed: {
    isDomainValid() {
      return !this.$isEmpty(this.form.domain_name);
    },
  },
};
</script>
